<template>
  <div class="latest-block">
    <div v-for="(item, i) in list" :key="item.blockHash + i" class="block-item" @click="goDetailFn(item)">
      <div class="left">
        <div class="height text-num">{{ item.blockHeight }}</div>
      </div>
      <div class="right">
        <div class="first-line">
          <div class="hash">{{ item.blockHash }}</div>
        </div>
        <div class="second-line">
          <div class="num">{{ item.txCount }} Txns</div>
          <div class="seperator">|</div>
          <div class="time">{{ item.createAt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LatestBlock',
  data() {
    return {
      list: []
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getNewBlockListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getNewBlockListFn()
    }
  },
  methods: {
    ...mapActions(['getBlockLists']),
    // 获取最新区块
    getNewBlockListFn() {
      let params = {
        offset: 0,
        limit: 3,
        chainId: this.$store.state.home.chainCid
      }
      this.getBlockLists(params).then(res => {
        this.list = { ...res.items }
        this.$store.commit('updateLoading', false);
      })
    },
    // 跳转详情页
    goDetailFn(val) {
      this.$router.push({
        name: 'blockDetail',
        query: { blockHeight: val.blockHeight }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.latest-block {
  width: 100%;
  height: 100%;
  padding: var(--home-block-padding);

  .block-item:hover {
    cursor: pointer;
    background: var(--home-block-item-hover-background-color);
  }

  .block-item {
    height: var(--home-block-item-height);
    background: var(--home-block-item-background-color);
    border-radius: var(--home-block-item-border-radius);
    margin-bottom: var(--home-block-item-margin-bottom);
    display: flex;
    align-items: center;
    padding: var(--home-block-item-padding);

    .left {
      height: var(--home-block-item-icon-height);
      background-image: var(--home-block-item-icon-url);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: var(--home-block-item-icon-padding);
      margin-right: var(--home-block-item-icon-margin-right);

      .height {
        height: var(--home-block-item-info-height);
        min-width: var(--home-block-item-info-min-width);
        color: var(--home-block-item-left-section-color);
        font-size: var(--home-block-item-info-height);
        font-style: normal;
        font-weight: 500;
        text-align: center;
        line-height: var(--home-block-item-info-height);
      }
    }

    .right {
      height: var(--home-block-item-des-height);
      color: var(--home-block-item-right-section-color);
      font-size: var(--home-block-item-des-fontsize);
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      overflow: hidden;

      .first-line {
        height: var(--home-block-item-des-firstline-height);
        line-height: var(--home-block-item-des-firstline-height);
        margin-bottom: var(--home-block-item-des-firstline-margin-bottom);

        .hash {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .second-line {
        display: flex;
        align-items: center;
        height: var(--home-block-item-des-secondline-height);
        line-height: var(--home-block-item-des-secondline-height);
        font-size: var(--home-block-item-des-secondline-fontsize);
        color: var(--home-block-item-right-second-line-color);

        .time {
          color: #517080;
        }

        .seperator {
          margin: var(--home-block-item-des-secondline-seperator-margin);
        }
      }
    }
  }
}
</style>
